import { createStructuredSelector } from 'reselect';

import { showServicesSelector } from '@selectors/filterServicesSelector';

export const servicesCatalogModalSelector = createStructuredSelector({
  visible: showServicesSelector,
});

export type ServicesCatalogModalProps = {
  visible: boolean;
};
